function isEditableTarget(el) {
  if (!el || el.nodeType !== 1) return false;
  if (el.isContentEditable) return true;
  const tag = el.tagName;
  if (tag === "TEXTAREA") return true;
  if (tag === "SELECT") return true;
  if (tag === "INPUT") {
    const type = (el.type || "text").toLowerCase();
    return !["button", "submit", "reset", "checkbox", "radio", "file", "hidden", "image", "color"].includes(type);
  }
  return false;
}
function syncViewportHeight() {
  const measure = () => {
    const vv = window.visualViewport;
    let h = vv?.height ?? window.innerHeight;
    if (!Number.isFinite(h) || h < 120) h = window.innerHeight;
    let w = vv?.width ?? window.innerWidth;
    if (!Number.isFinite(w) || w < 80) w = window.innerWidth;
    const top = vv?.offsetTop ?? 0;
    return { h: Math.round(h), w: Math.round(w), top: Math.max(0, Math.round(top)) };
  };
  const writeVars = (h, w, top) => {
    const root = document.documentElement;
    root.style.setProperty("--app-vh", `${h}px`);
    root.style.setProperty("--app-vw", `${w}px`);
    root.style.setProperty("--vv-offset", "0px");
    root.style.setProperty("--vv-offset-x", "0px");
    root.style.setProperty("--vv-width", `${w}px`);
    root.style.setProperty("--vv-keyboard-offset", "0px");
    root.style.setProperty("--vv-top", `${top}px`);
  };
  const update = () => {
    const { h, w, top } = measure();
    writeVars(h, w, top);
    // Overlay keyboards (iOS WKWebView): the visual viewport shrinks while the layout
    // viewport keeps its full height. Flag it on <html> so CSS can drop the bottom
    // safe-area inset and decorative offsets while the keyboard is up. On Android the
    // layout viewport resizes with the keyboard, so this stays off there.
    document.documentElement.classList.toggle("kb-open", window.innerHeight - h > 120);
  };
  const schedule = () => {
    requestAnimationFrame(() => {
      update();
      requestAnimationFrame(update);
    });
  };
  const lockBodyScroll = () => {
    if (window.scrollY !== 0 || window.scrollX !== 0) {
      window.scrollTo(0, 0);
    }
    if (document.documentElement.scrollTop !== 0) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body && document.body.scrollTop !== 0) {
      document.body.scrollTop = 0;
    }
  };
  schedule();
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", schedule);
    window.visualViewport.addEventListener("scroll", schedule);
  }
  window.addEventListener("resize", schedule);
  window.addEventListener("orientationchange", () => {
    setTimeout(schedule, 400);
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") setTimeout(schedule, 120);
  });
  document.addEventListener("focusin", (e) => {
    if (isEditableTarget(e.target)) {
      for (let i = 0; i < 30; i += 1) setTimeout(lockBodyScroll, i * 30);
    }
    schedule();
  }, true);
  document.addEventListener("focusout", () => {
    setTimeout(() => {
      lockBodyScroll();
      schedule();
    }, 80);
  }, true);
  window.addEventListener("scroll", lockBodyScroll, { passive: true, capture: true });
  document.addEventListener("scroll", lockBodyScroll, { passive: true, capture: true });
}
export {
  syncViewportHeight
};
